import useUserStore from "../zustand/user";
import { createAlert } from "../utils/alertUtils";
import useLocalizationStore from "../zustand/localization";

// Intercept Request and add Authorization header if token exists
export const interceptRequest = (requestConfig) => {
  const { token } = useUserStore.getState(); // Get token from Zustand store
  const lang = useLocalizationStore.getState().language;

  // Set headers
  requestConfig.headers = {
    ...requestConfig.headers,
    "Accept-Language": lang, // ✅ Add lang in header
    language: lang,
  };
  if (token) {
    requestConfig.headers.authorization = `Bearer ${token}`;
  }

  return requestConfig;
};

// Handle request error
export const interceptRequestError = (error) => {
  return Promise.reject(error);
};

// Intercept Response (successful response handling)
export const interceptResponse = (response) => {
  return response;
};

// Intercept Response Error to handle 401 and 423 errors
export const interceptResponseError = async (error) => {
  console.log("🚀 ~ interceptResponseError ~ error:", error);
  const { setUserLogout } = useUserStore.getState(); // Access Zustand store

  // // Handle 423 or 401 errors that are not related to the refresh process
  if (error.response?.status === 423 || error.response?.status === 401) {
    createAlert({
      type: "error",
      message: "",
      title: "",
      status: true,
      notification: {
        title: error.response.data.messge || error.response.data.message,
        body: error.response.data.messge || error.response.data.message,
        titleArabic: error.response.data.messge || error.response.data.message,
        bodyArabic: error.response.data.messge || error.response.data.message,
      },
    });

    setUserLogout();
    // window.localStorage.clear();
  }

  return Promise.reject(error);
};
